<template>
    <div class="activeDetails">
        <el-form :model="form" :rules="rules" ref="form" label-width="130px">
            <div class="spackage padding-20 bgc box-shadow">
                <div>
                        <p class="title">基本信息</p>
                        <el-form-item label="所属社群" required>
                            <template v-if="form.status === 30 || statusdisabled == true || form.status === 100">
                                {{ form.assname }}
                            </template>
                            <template v-else>
                                <el-select v-model="form.assinnerid" placeholder="选择社群" :disabled="statusdisabled">
                                    <el-option v-for='items in sqlist' :label="items.name"  :disabled="statusdisabled" :value='items.innerid' :key="items.innerid"></el-option>
                                </el-select>
                                <span @click="newpage('MOPIndex')" style="margin-left: 20px; color: #409EFF; cursor: pointer;">社群维护</span>
                                <span @click="initsearchAssociationList" style="margin-left: 20px; color: #409EFF; cursor: pointer;">刷新社群</span>
                            </template>
                            

                        </el-form-item>
                        <el-form-item label="活动名称" required>
                            <el-input v-model="form.title" class="activename" placeholder="输入活动名称，不超过30个字" maxlength="30"></el-input>
                        </el-form-item>
                        <el-form-item label="上架类型">
                            <div class="flex">
                               <el-radio-group v-model="form.onlinetype">
                                    <el-radio :label='1' :disabled="disabled">单次上架</el-radio>
                                    <el-radio :label='2' :disabled="disabled">周期性上架</el-radio>
                               </el-radio-group>

                                <el-tooltip class="item" effect="dark" content="需设置滚动时间，在该时间段自动上架活动。" placement="top">
                                    <i class="el-icon-warning"></i>
                                </el-tooltip>
                            </div>
                            <p style="font-size: 12px; color: #C0C4CC">上架类型提交后将不能修改，请谨慎填写。</p>
                        </el-form-item>

                         <el-form-item label="活动有效期" prop="begintime">
                            <el-date-picker v-model="form.begintime" value-format="yyyy-MM-dd HH:mm"  format="yyyy-MM-dd HH:mm"  :disabled="statusdisabled" type="datetime" placeholder="选择活动开始时间"></el-date-picker>
                            <span class="to" style="margin: 0 5px"> 至 </span>
                            <el-date-picker v-model="form.endtime" value-format="yyyy-MM-dd HH:mm"  format="yyyy-MM-dd HH:mm"  type="datetime" placeholder="选择活动结束时间"></el-date-picker>
                        </el-form-item>

                        <!-- <el-form-item label="活动有效期" required>
                           <el-date-picker v-model="timeData" type="datetimerange" format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:mm" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" class="item"></el-date-picker>
                        </el-form-item> -->

                        <template v-if="form.onlinetype == 2">
                             <el-form-item label="周期类型" required>
                                <el-select v-model="form.scheduletype">
                                    <el-option v-for="item in scheduletypeList" :disabled="statusdisabled" :label="item.label" :key="item.value" :value="item.value"></el-option>
                                </el-select>
                                <span style="margin-left: 15px; font-size: 12px; color: #C0C4CC">活动配置时间段应在活动有效期内进行配置，否则无法生效。</span>
                            </el-form-item>
                            <el-form-item label="时间段设置" required>

                                    <el-button type="primary" @click="addTime" v-if="statusdisabled == false">增加时间段</el-button>
                                    <el-button type="info" v-if="statusdisabled == true">增加时间段</el-button>
                                    <template v-if="form.scheduletype == 1">
                                        <div v-for="(schtime,index) in scheduletimeDay">
                                             <el-time-picker
                                                is-range
                                                v-model="schtime.time"
                                                range-separator="至"
                                                start-placeholder="开始时间"
                                                end-placeholder="结束时间"
                                                placeholder="选择时间范围"
                                                format="HH:mm">
                                            </el-time-picker>
                                            <i class="el-icon-delete timedel" v-if="index > 0 && statusdisabled == false" @click="delItem(scheduletimeDay,index)"></i>
                                        </div>
                                    </template>
                                    <!-- end 日 -->
                                    
                                     <template v-if="form.scheduletype == 2">
                                        <div class="flex" v-for="(schtime, index) in scheduletimeWeek">
                                                <el-select v-model="schtime.beginschedule" placeholder="请选择时间" style="width: 80px" class="input">
                                                    <el-option :disabled="statusdisabled" v-for="week in weekList" :label="week.label" :value="week.value" :key="week.value"></el-option>
                                                </el-select>
                                                <el-time-picker
                                                    v-model="schtime.begintime"
                                                    format="HH:mm"
                                                    value-format='HH:mm'
                                                    :picker-options="{selectableRange: '00:00:00 - 23:59:00'}"
                                                    placeholder="选择开始时间"
                                                    style="width: 200px" class="input">
                                                </el-time-picker>
                                                <span class="input">至</span>
                                                <el-select v-model="schtime.endschedule" placeholder="请选择时间" style="width: 80px" class="input">
                                                    <el-option v-for="week in weekList" :disabled="statusdisabled" :label="week.label" :value="week.value" :key="week.value"></el-option>
                                                </el-select>
                                                <el-time-picker
                                                    v-model="schtime.endtime"
                                                    format="HH:mm"
                                                    value-format='HH:mm'
                                                    :picker-options="{selectableRange: '00:00:00 - 23:59:00'}"
                                                    placeholder="选择结束时间"
                                                    style="width: 200px">
                                                </el-time-picker class="input">
                                                <i class="el-icon-delete timedel" v-if="index > 0 && statusdisabled == false" @click="delItem(scheduletimeWeek,index)"></i>
                                        </div>
                                     </template>
                                    <!-- end 周 -->

                                    <template v-if="form.scheduletype == 3">
                                        <div class="flex" v-for="(schtime, index) in scheduletimeMonth">
                                                <el-select v-model="schtime.beginschedule" style="width: 80px" class="input">
                                                    <el-option v-for="month in 31" :disabled="statusdisabled" :label="month + '号'" :value="month" :key="month"></el-option>
                                                </el-select>
                                                <el-time-picker
                                                    v-model="schtime.begintime"
                                                    format="HH:mm"
                                                    value-format='HH:mm'
                                                    :picker-options="{selectableRange: '00:00:00 - 23:59:00'}"
                                                    placeholder="选择开始时间"
                                                    style="width: 200px"
                                                    class="input">
                                                </el-time-picker>
                                                <span>至</span>
                                                <el-select v-model="schtime.endschedule" style="width: 80px" class="input">
                                                    <el-option v-for="month in 31" :disabled="statusdisabled" :label="month + '号'" :value="month" :key="month"></el-option>
                                                </el-select>
                                                <el-time-picker
                                                    v-model="schtime.endtime"
                                                    format="HH:mm"
                                                    value-format='HH:mm'
                                                    :picker-options="{selectableRange: '00:00:00 - 23:59:00'}"
                                                    placeholder="选择结束时间"
                                                    style="width: 200px" class="input">
                                                </el-time-picker>
                                                <i class="el-icon-delete timedel" v-if="index > 0 && statusdisabled == false" @click="delItem(scheduletimeMonth,index)"></i>
                                        </div>
                                        
                                    </template>
                                    <!-- end 月 -->

                                    <template v-if="form.scheduletype == 4">
                                          <div class="flex" v-for="(schtime, index) in scheduletimeZdy">
                                                <el-date-picker class="input"
                                                    v-model="schtime.beginschedule"
                                                    type="date"
                                                    placeholder="选择日期"
                                                    style="width: 140px">
                                                </el-date-picker> 
                                                <el-time-picker class="input"
                                                    v-model="schtime.begintime"
                                                    format="HH:mm"
                                                    value-format='HH:mm'
                                                    :picker-options="{selectableRange: '00:00:00 - 23:59:00'}"
                                                    placeholder="选择开始时间"
                                                    style="width: 100px">
                                                </el-time-picker>
                                                <span class="input">至</span>
                                                <el-date-picker class="input"
                                                    v-model="schtime.endschedule"
                                                    type="date"
                                                    placeholder="选择日期"
                                                    style="width: 140px">
                                                </el-date-picker> 
                                                <el-time-picker class="input"
                                                    v-model="schtime.endtime"
                                                    format="HH:mm"
                                                    value-format='HH:mm'
                                                    :picker-options="{selectableRange: '00:00:00 - 23:59:00'}"
                                                    placeholder="选择结束时间"
                                                    style="width: 100px">
                                                </el-time-picker>
                                                <i class="el-icon-delete timedel" v-if="index > 0 && statusdisabled == false" @click="delItem(scheduletimeZdy,index)"></i>
                                        </div>
                                    </template>
                                    <!-- end 自定义 -->
                            </el-form-item>

                        </template>

                        <el-form-item label="活动logo" required>
                           <div class="upload">
                                <upload class="avatar-uploader" :imgRule="imgRule"  @setImage="setCoverfile" :uploadType="uploadType" ref="coverfile"></upload>
                            </div>
                            <div class="position">
                                <!-- <el-button type="warning" @click="dialogVisible = true">系统头像</el-button> -->
                                <p>建议尺寸750*420px的JPG、PNG格式， 图片小于2M</p>
                            </div>
                        </el-form-item>
                        <el-form-item label="每人可购次数" required>
                            <el-input v-model="form.maxbuycount" placeholder="请填写可购次数" type="num" class="maxnum"></el-input>
                            <p style="font-size: 12px; color: #C0C4CC">0为不限制购买次数</p>
                        </el-form-item>
                        <el-form-item label="活动说明">
                           <el-input type="textarea" v-model="form.eventdesp" placeholder="输入活动说明，120字以内。" style="width: 480px; height: 135px;"></el-input>
                        </el-form-item>
                </div>
                <div>
                    <p class="title">折扣信息</p>
                    <el-form-item label="折扣计算类型">
                        <div class="flex" style="margin-top: 11px">
                                <el-radio-group v-model="form.rebatecaltype">
                                    <el-radio :label='1' :disabled="statusdisabled">按订单</el-radio>
                                    <el-radio :label='2' :disabled="statusdisabled">按商品数</el-radio>
                                </el-radio-group>
                                <el-tooltip class="item" effect="dark" content="按订单：折扣阶梯以发生的订单数计算 按商品数：折扣阶梯以订单产生的商品数计算，如一个订单有5件商品，则满足设定的5单95折" placement="top" style="width: 221px;">
                                    <i class="el-icon-warning"></i>
                                </el-tooltip>
                            </div>
                    </el-form-item>
                    <el-form-item label="折扣类型">
                        <div class="flex" style="margin-top: 11px">
                                <el-radio-group v-model="form.rebatetype">
                                    <el-radio :label='1' :disabled="statusdisabled">折扣比例</el-radio>
                                    <el-radio :label='2' :disabled="statusdisabled">固定返现</el-radio>
                                </el-radio-group>
                                <el-tooltip class="item" effect="dark" content="折扣比例：如5单折扣95折，10单折扣9折 固定返现：如返现金额5元" placement="top" style="width: 221px;">
                                    <i class="el-icon-warning"></i>
                                </el-tooltip>
                            </div>
                    </el-form-item>
                    <el-form-item label="折扣设置" prop='rebatvalue'>
                        <template v-if="form.rebatetype === 1">
                            <el-button type="primary" @click="addZk" v-if="statusdisabled == false">新增折扣</el-button>
                            <el-button type="info" v-if="statusdisabled == true">新增折扣</el-button>
                             <span style="margin-left: 10px; font-size: 12px; color: #C0C4CC">折扣设置数量不能超过5条</span>
                            <div class="zk-list">
                                <!-- <div class="flex zk-item" v-for="(items,index) in form.offerinfo"> -->
                                <div class="flex zk-item" v-for="(items,index) in zkofferinfo">
                                    <p v-if='form.rebatecaltype == 1'>订单数满</p>
                                    <p v-else>商品数满</p>
                                     <el-input v-model="items.minordercount" type="num" placeholder="输入整数"  :disabled="statusdisabled"></el-input>
                                    <p>个 原价的</p>
                                    <el-input v-model="items.rebatvalue" type="num" placeholder="输入折扣"  :disabled="statusdisabled"></el-input> % (请输入1-100)
                                    <i class="el-icon-delete timedel" v-if="index > 0 && statusdisabled == false" @click="delItem(zkofferinfo, index)"></i>
                                </div>
                            </div>
                        </template>
                        <template v-if="form.rebatetype === 2">
                            <el-button type="primary" @click="addZk" v-if="statusdisabled == false">新增返现</el-button>
                            <el-button type="info" v-if="statusdisabled == true">新增返现</el-button>
                             <span style="margin-left: 10px; font-size: 12px; color: #C0C4CC">返现设置数量不能超过5条</span>
                            <div class="zk-list">
                                <!-- <div class="flex zk-item" v-for="(items,index) in form.offerinfo"> -->
                                <div class="flex zk-item" v-for="(items,index) in gdofferinfo">    
                                    <p v-if='form.rebatecaltype == 1'>订单数满</p>
                                    <p v-else>商品数满</p>
                                    <el-input v-model="items.minordercount" type="num" placeholder="输入整数" :disabled="statusdisabled"></el-input>
                                    <p>个 返现值</p>
                                    <el-input v-model="items.rebatvalue" type="num" placeholder="输入数字" :disabled="statusdisabled"></el-input>
                                    <i class="el-icon-delete timedel" v-if="index > 0 && statusdisabled == false" @click="delItem(gdofferinfo, index)"></i>
                                </div>
                            </div>
                        </template>
                        
                    </el-form-item>
                </div>
                <!--  end 基本信息 -->
                <div>
                    <p class="title">抽奖信息</p>
                    <el-form-item label="是否开通抽奖">
                       <el-switch v-model="form.isopenreward"></el-switch>
                       <span style="margin-left: 20px; color: #c0c4cc;">开通抽奖有助于留存用户</span>
                    </el-form-item>
                    <template v-if="form.isopenreward == true">
                         <el-form-item label="最低订单数" required>
                            <el-input-number v-model="form.minordercount" @change="handleChange" :min="0">
                                <span style="margin-left: 20px; color: #c0c4cc;">达到最低订单数才能抽奖, 0为不限制</span>
                            </el-input-number>
                        </el-form-item>
                        <el-form-item label="抽奖个数" required>
                            <el-input-number v-model="form.rewardcount" @change="handleChange" :min="1"></el-input-number>
                        </el-form-item>
                        <el-form-item label="奖品类型">
                            <div>
                                <el-radio-group v-model="form.prizetype">
                                    <el-radio :label='1'>优惠券</el-radio>
                                    <!-- <el-radio :label='2'>直接返现</el-radio> -->
                                </el-radio-group>
                            </div>
                            <el-form-item label="优惠金额" v-if="form.prizetype === 1" required>
                                <div class="flex">
                                    <p>满</p>
                                    <el-input style="width: 120px" placeholder="输入数字" type="num" v-model="form.minordermoney"></el-input>
                                    <p>减</p>
                                    <el-input style="width: 120px" placeholder="输入数字" type="num" v-model="form.faceprice"></el-input>
                                </div>
                            </el-form-item>
                            <el-form-item label="有效期" v-if="form.prizetype === 1" required>
                                <div class="flex">
                                    <p>发放后</p>
                                    <el-input v-model="form.expiredays" placeholder="输入天数" type="num" style="width: 102px"></el-input>
                                    <p>内有效</p>
                                </div>
                            </el-form-item>
                            <el-form-item label="返现金额" v-if="form.prizetype === 2" required>
                                    <el-input v-model="form.rewardmoney" placeholder="输入数字" type="num" style="width: 230px"></el-input>
                            </el-form-item>
                        </el-form-item>
                    </template>
                </div>
            </div>
            <div class="spackage padding-20 bgc box-shadow">
                <div class="pay">
                    <p class="title">支付凭证</p>
                    <div style="float: left; max-width: calc(100% - 330px)">
                        <el-radio-group v-model="form.resulttype" style="width: 100%">
                            <div class="item">
                                <el-radio :label='1' :disabled="statusdisabled">普通型 <span class="bz">选择该状态后只显示自定义内容</span></el-radio>
                            </div>
                            <div class="item">
                                <el-radio :label='4' :disabled="statusdisabled">核销型  <span class="bz">选择核销型请注意完善门店信息</span></el-radio>
                            </div>
                            <div class="item">
                                <el-radio :label='5' :disabled="statusdisabled">配送型 <span class="bz">选择配送型需发布方自行配送</span></el-radio>
                            </div>
                        </el-radio-group>
                        
                        <el-input class="item" type="textarea" v-model="form.customcontent"  placeholder="在此输入自定义订单提示信息" style="width: 577px; height: 180px"></el-input>

                        <div class="btn">
                            <el-button @click="back">取消</el-button>
                            <el-button type="primary" @click="submit" v-if="form.status == 0 || form.status == 11 || form.status == 10 || !form.status">提交</el-button>
                        </div>
                    </div>

                    <div class="pztype">
                        <img src="@/common/images/communityPurchases/pztype-5.png" alt="type">
                        <img src="@/common/images/communityPurchases/pztype-1.png" alt="type" v-if="form.resulttype == 1 || form.resulttype == 5">
                        <img class="top" src="@/common/images/communityPurchases/pztype-2.png" alt="type" v-if="form.resulttype == 4">
                        <img class="top" src="@/common/images/communityPurchases/pztype-3.png" alt="type" v-if="form.resulttype == 4">
                        <div class="text top">
                            <template v-if="form.customcontent == ''">此区域可进行自定义，用户在配置参数时，采用后台自带的富文本编辑器进行编辑支付后的凭证内容。（该区域高度可随内容自适应伸缩）</template>
                            {{ form.customcontent }}
                        </div>
                        <img class="top" src="@/common/images/communityPurchases/pztype-4.png" alt="type" v-if="form.resulttype == 5">
                    </div>

                </div>
            </div>
        </el-form>
    </div>

</template>

<script>
import Upload from 'base/upload/upload'
import fecha from 'element-ui/src/utils/date';
import { mapActions} from 'vuex' // 引入 vuex 组件
import { downloadImage} from 'common/js/tools'
import {saveOrUpdateEventInfo, searchAssociationList, getEventDetail} from 'api/cPurchaseApi'
import $ from 'jquery'
import { async } from 'q';
export default {
    name: "ActiveDetails",
    data() {
        let checkdate = (rule, value, callback) => {
            let now = new Date().getTime(),
                begintime = '',
                endtime = '',
                vform = this.form

            if (vform.begintime || vform.endtime) {
                if (vform.begintime.length > 20) {
                begintime = this.switchTimeFormat(vform.begintime)
                } else {
                    begintime = vform.begintime
                }
                if (vform.endtime.length > 20) {
                    endtime = this.switchTimeFormat(vform.endtime)
                } else {
                    endtime = vform.endtime
                }
            }

            if (!vform.begintime || !vform.endtime) {
                if (!vform.begintime) {
                    callback('请选择活动开始时间')
                } else if (!vform.endtime) {
                    callback('请选择活动结束时间')
                }
            } else if (new Date(endtime).getTime() === new Date(begintime).getTime() || new Date(endtime).getTime() < new Date(begintime).getTime()) {
                
                // console.log('endtime', moment(this.form.endtime).utcOffset(480).format('YYYY-MM-DD HH:mm'))
                
                // console.log('begintime', moment(this.form.begintime).utcOffset(480).format('YYYY-MM-DD HH:mm'))
                
                callback('活动开始时间不能小于等于结束时间')
            } else {
                console.log('endtime', endtime)
                console.log('begintime', begintime)
                // console.log('endtime', moment(this.form.endtime).utcOffset(480).format('YYYY-MM-DD HH:mm'))
                // console.log('begintime', moment(this.form.begintime).utcOffset(480).format('YYYY-MM-DD HH:mm'))
                callback()
            }
        }
        let inputrebatvalue = (rule, value, callback) => {
            let numRegular = /^[+]{0,1}(\d+)$/

            console.log(this.form.rebatecaltype)

            if (this.form.rebatecaltype == 1) {

                for(let i = 0; i < this.zkofferinfo.length; i++) {
                    
                    let num = this.zkofferinfo[i].rebatvalue

                    // console.log(this.zkofferinfo[i].rebatvalue)
                    // console.log(num)
                    // console.log(numRegular.test(num))
                    
                    if (!numRegular.test(num)) {
                        callback('请输入整数')
                    }
                }
            }
        }
        return {
            imgRule: {
                cls: 'icon_upload',
                accept: 'image/png,image/jpeg',
                size: 2,
                width: '',
                height: ''
            },
             uploadType: {
                catecode: '95',
                datatype: 'IMAGE'
            },
        
            disabled: false,    // 类型更改
            statusdisabled: false,
            sqlist: [], // 社群列表
            weekList: [{label:'周一', value: 1},{label:'周二', value: 2},{label:'周三', value: 3},{label:'周四', value: 4},{label:'周五', value: 5},{label:'周六', value: 6},{label:'周日', value: 7}], // 周控制
            scheduletimeDay: [],    // 时间段 日
            scheduletimeWeek: [],  // 时间段 周
            scheduletimeMonth: [], //时间段月
            scheduletimeZdy: [],    // 时间段自定义
            zkofferinfo: [{innerid:'', minordercount: '',rebatvalue: ''}],    // 折扣比例
            gdofferinfo: [{innerid:'', minordercount: '',rebatvalue: ''}], // 固定返现
            // startTime: [new Date(2019, 9, 29, 18, 10),new Date(2019, 9, 29, 18, 30)],
            endTime: '',
            scheduletypeList: [{label:'日',value:1},{label:'周',value:2},{label:'月',value:3},{label:'自定义',value:4}], // 滚动上架周期类型
            timeData: '', // 活动有效期
            form: {
                num: 1,
                innerid: this.$route.query.eventinnerid, // 活动innerid
                assinnerid: '', // 社群innerid
                title: '', //活动名称
                onlinetype: 1, // 上架类型：1一次性 2周期性
                scheduletype: 1, // 上架周期类型：1按日 2按周 3按月 4自定义
                scheduletime: [], // 开始或者结束时间(json传参，可能涉及多个)
                begintime: '', //开始时间，只带时间
                endtime: '',// 结束时间，只带时间
                coverattid: '', // 活动LogoID
                coveratturlid: '', // 活动LogoUrl地址
                maxbuycount: 0, // 用户购买次数
                eventdesp: '',// 活动详情
                rebatecaltype: 1, // 折扣计算类型 1 按订单 2 按商品
                rebatetype: 1, // 折扣类型：1折扣比例 2固定返现
                // minordercount: '',// 上架周期类型：1按日 2按周 3按月
                offerinfo: [{innerid:'', minordercount: '',rebatvalue: ''}],// minordercount 最低订单数  rebatvalue //折扣值  折扣比如填写折扣如95折，固定返现填写返现金额如5元
                isopenreward: true, // 是否开通抽奖
                rewardcount: 1,// 抽奖个数
                prizetype: 1, // 奖品类型：1优惠券-默认、2直接返现
                faceprice: '', // 优惠券-优惠金额
                minordermoney: '', // 优惠券-满多少使用
                // offerinfo: '', //优惠金额和满好多使用 (json传参，可能多个)
                expiredays: '', // 发放后多少天有效
                rewardmoney: '', // 直接返现金额
                resulttype: 1, //凭证类型:1自定义 4核销码 5配送型
                customcontent: '', //自定义内容：除链接外其他有效
                minordercount: 0, // 最低订单数
                producttotalcount: '', // 产品总数量
            },
            rules: {
                begintime: [
                    {validator: checkdate, trigger: 'blur', required: true}
                ],
                rebatvalue: [
                    {validator: inputrebatvalue, trigger: 'blur', required: true}
                ],
            }
        }
        
    },
    created() {
        this.scheduletimeDay.push({ innerid: '', time: [new Date(2019, 9, 29, 0, 0),new Date(2019, 9, 29, 23, 59)]})
        // this.scheduletimeWeek.push({beginschedule: 1, begintime: new Date(2019, 9, 29, 0, 0), endschedule: 1, endtime: new Date(2019, 9, 29, 23, 59)})
        // this.scheduletimeMonth.push({beginschedule: 1, begintime: new Date(2019, 9, 29, 0, 0), endschedule: 1, endtime: new Date(2019, 9, 29, 23, 59)})
        // this.scheduletimeDay.push({ time: ['', '']})
        this.scheduletimeWeek.push({beginschedule: 1, begintime: '', endschedule: 1, endtime: ''})
        this.scheduletimeMonth.push({beginschedule: 1, begintime: '', endschedule: 1, endtime: ''})
        this.scheduletimeZdy.push({beginschedule: '', begintime: '', endschedule: '', endtime: ''})

        //  this.scheduletimeZdy.push({beginschedule: '', begintime: new Date(2019, 9, 29, 0, 0), endschedule: '', endtime: new Date(2019, 9, 29, 23, 59)})
    },
    mounted() {
        this.initsearchAssociationList()
        // 活动详情
        this.activeDetails()

        if (this.form.innerid !== undefined && this.form.innerid.length > 1) {
            this.disabled = true
        }
        // $('.el-input-number .el-input input').attr('disabled',true)
        // console.log($('.el-input-number .el-input input'))
    },
    methods: {
        back() {    // 返回
            this.$router.go(-1)
        },
        newpage(name) { // 打开新页面
            let routerUrl = this.$router.resolve({name: name})
            window.open(routerUrl.href,'_blank')
        },
        activeDetails() {
            if (this.form.innerid !== '' && this.form.innerid !== undefined) {
                this.setLoading(true)
                getEventDetail({
                    data: {eventinnerid: this.form.innerid},
                    success: data => {
                        this.setLoading(false)
                        
                        this.form = data.data
                     
                        // this.timeData = [this.form.begintime,this.form.endtime] // 活动有效期
                        
                        this.$refs.coverfile.setImage(this.form.coveratturlid) // 活动图片设置

                        // 判断折扣类型 类型
                        if (this.form.rebatetype === 1) {

                            this.zkofferinfo = JSON.parse(this.form.offerinfo)
                        } else {

                            this.gdofferinfo = JSON.parse(this.form.offerinfo)
                        }
                        // this.form.offerinfo = JSON.parse(this.form.offerinfo)   // 折扣类型 转json

                        this.form.isopenreward = this.form.isopenreward == 1 ? true : false // 是否开通抽奖
                        this.form.rebatecaltype = this.form.rebatecaltype == 1 ? true : false // 折扣信息

                        this.form.scheduletime = JSON.parse(this.form.scheduletime) // 时间段设置转成json
                        // 日、周、月、自定义 时间转换
                        this._TimeUpdateTransformation(this.form.scheduletime, this.form.scheduletype)

                        

                        // 当前页面状态 
                        switch(this.form.status) {
                            case 0: // 未开始
                                break
                            case 10:    // 进行中
                            case 11:    // 暂停中
                                this.statusdisabled = true
                                break
                            case 30:    // 已结束
                                break
                            case 100:   // 已删除
                                break
                        }

                        console.log(data.data)
                    },
                    error: data => {
                        this.setLoading(false)
                        this.$message.error(this.data.msg)
                    }
                })
            }
        },
       
        initsearchAssociationList() {
            this.setLoading(true)
            // 社群列表初始化
            searchAssociationList({
                data: {},
                success: data => {
                     this.setLoading(false)
                    this.sqlist = data.data.content
                },
                error: data => {
                     this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        addTime() {  // 增加时间段
            let scheduletype = this.form.scheduletype // 时间段类型 

            // 针对添加时间段的类型进行判断 然后对数据进行初始化
            if (scheduletype == 1) {
                // 日  初始化时间才能使用
                this.scheduletimeDay.push({ innerid: '', time: [new Date(), new Date('2019-10-12 23:59')]})
            } else if (scheduletype == 2) {
                // 周
                this.scheduletimeWeek.push({ beginschedule: 1, begintime: '', endschedule: 1, endtime: ''})
            } else if (scheduletype == 3) {
                // 月
                this.scheduletimeMonth.push({ beginschedule: 1, begintime: '', endschedule: 1, endtime: ''})
            } else if (scheduletype == 4) {
                // 自定义
                this.scheduletimeZdy.push({ beginschedule: '', begintime: '', endschedule: '', endtime: ''})
            }
        },
        delItem(item,index) { // 删除自定义的时间段 / 折扣段
            item.splice(index,1)
            // let arr = [];
            // for (let i = 0; i < item.length; i++ ) {
            //     if (i !== index) {
            //         arr.push(item[i])
            //     }
            // }
            // this.$nextTick({
            //     item = JSON.parse(JSON.stringify(arr))
            // })
        },
        addZk() {   // 增加折扣
            if (this.form.rebatetype == 1) {
                // 折扣
                if (this.zkofferinfo.length < 5) {
                    this.zkofferinfo.push({innerid:'', minordercount: '',rebatvalue: ''})
                } else {
                    this.$message.info('折扣设置数量不能超过5条')
                }
            } else {
                // 固定
                if (this.gdofferinfo.length < 5) {
                    this.gdofferinfo.push({innerid:'', minordercount: '',rebatvalue: ''})
                } else {
                    this.$message.info('返现设置数量不能超过5条')
                }
            }
            
        },
        switchTimeFormat (time) {
                return time.split('T')[0] + ' ' + time.split('T')[1].split(':00.000+0000')[0]
        },
        submit() {  // 增加/修改活动

            let apidata = JSON.parse(JSON.stringify(this.form)),
                alertText = '',
                $this = this
            
            if (apidata.innerid == '' || apidata.innerid == undefined) {
                // 新增
                if (apidata.onlinetype == 1) {
                    // 一次性活动
                    alertText = '请确认保存活动信息吗？'
                } else {
                    // 周期性活动
                    alertText = '活动保存之后将自动启动活动任务，请确认保存活动信息吗？'
                }

            } else {
                // 修改
                if (apidata.onlinetype == 1) {
                    // 一次性活动
                    alertText = '请确认修改活动信息吗？'
                } else {
                    // 周期性活动
                    alertText = '活动修改之后对未启动的任务有效，请确认保存活动信息吗？'
                }
            }

             apidata.scheduletime =  this._Dayslot()
            // apidata.begintime = this._TimeZH(this.timeData[0])
            // apidata.endtime = this._TimeZH(this.timeData[1])

            if (apidata.begintime.length > 20) {
                apidata.begintime =  $this.switchTimeFormat(apidata.begintime)
            } else {
                apidata.begintime =  $this._TimeZH(apidata.begintime)
            }      

             if (apidata.endtime.length > 20) {

                apidata.endtime =  $this.switchTimeFormat(apidata.endtime)
            } else {
                apidata.endtime =  $this._TimeZH(apidata.endtime)
            }

            // 判断类型
            if (apidata.rebatetype === 1) {
                apidata.offerinfo = JSON.stringify($this.zkofferinfo)
            } else {
                apidata.offerinfo = JSON.stringify($this.gdofferinfo)
            }
            // apidata.offerinfo = JSON.stringify(apidata.offerinfo)
            apidata.scheduletime = JSON.stringify(apidata.scheduletime)
            apidata.isopenreward = apidata.isopenreward == true?1:0
            apidata.rebatecaltype == apidata.rebatecaltype == true ? 1 : 0


             this.$confirm(alertText, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: false
                }).then( async () => {
            
                    this.setLoading(true)
                    // 增加 
                    saveOrUpdateEventInfo({
                        data: apidata,
                        success:data => {
                            this.setLoading(false)
                            this.$message.success('操作成功')

                            // 前往活动跳转页面
                            this.$router.push({name: 'ActivetionAdmin'})
                        },
                        error:data => {
                            this.setLoading(false)
                            this.$message.error(data.msg)
                        }
                    })
                }).catch(() => {})
        },
        _TimeUpdateTransformation(json,type) {   // 编辑状态下时间转换
            switch (type) {
                case 1:   // 日
                    // this.scheduletimeDay.push({ time: [new Date(2019, 9, 29, 0, 0),new Date(2019, 9, 29, 23, 59)]})
                    this.scheduletimeDay = []
                    for (let i = 0; i < json.length; i++) {
                        this.scheduletimeDay.push({ innerid: json[i].innerid, 
                        time: [
                            new Date('2019-09-21 '+json[i].begintime),
                            new Date('2019-09-21 '+json[i].endtime)
                        ]})
                        // console.log({ innerid: json[i].innerid, time: [2019, 9, 29, json[i].begintime.split(":")[0], json[i].begintime.split(":")[1],
                        // new Date(2019, 9, 29, json[i].endtime.split(":")[0], json[i].endtime.split(":")[1])]})
                        
                        console.log(this._timeSplit(json[i].endtime, 1))
                    }
                    console.log('测试日',this.scheduletimeDay)
                    break
                case 2:   // 周
                    this.scheduletimeWeek = json
                    break
                case 3:   // 月 
                    this.scheduletimeMonth = json
                    break
                case 4:   // 自定义
                    console.log(json)
                    this.scheduletimeZdy = json
                    for (let i = 0; i < this.scheduletimeZdy.length; i++) {
                        // scheduletimeZdy[i].begintime
                        this.scheduletimeZdy[i].beginschedule = new Date(this.scheduletimeZdy[i].begintime)
                        this.scheduletimeZdy[i].endschedule = new Date(this.scheduletimeZdy[i].endtime)

                        this.scheduletimeZdy[i].begintime = new Date(this.scheduletimeZdy[i].begintime)
                        this.scheduletimeZdy[i].endtime = new Date(this.scheduletimeZdy[i].endtime)
                        // console.log('_TimeUpdateTransformation',  this.scheduletimeZdy[i].endtime)
                    }
                    break
            }
        },
        _timeSplit(data,index) {
            return parseInt(data.split(":")[index])
        },
        _TimeZH(date, split) { // 时间转换
            date = fecha.format(new Date(date), 'yyyy-MM-dd HH:mm')
            if (split) {
               if (split == 1) {
                    // 分割时间串
                    date = date.split(' ')[1]
               } else if (split == 2) {
                    date = date.split(' ')[0]
               }
            }
            return date
        },
        _Dayslot() {// 处理时间段
            let arr = []
            if (this.form.scheduletype == 1) {  // 日
                for (let i = 0; i < this.scheduletimeDay.length; i++ ) {
                    arr.push({
                        innerid: this.scheduletimeDay[i].innerid,
                        beginschedule: '',
                        begintime: this._TimeZH(this.scheduletimeDay[i].time[0],1),
                        endschedule: '',
                        endtime: this._TimeZH(this.scheduletimeDay[i].time[1],1)
                    })
                }
            } else if (this.form.scheduletype == 2) {
                  arr = JSON.parse(JSON.stringify(this.scheduletimeWeek))  // 时间段 周
           
            } else if (this.form.scheduletype == 3) {
                  arr = JSON.parse(JSON.stringify(this.scheduletimeMonth))  // 时间段 月
           
            } else if (this.form.scheduletype == 4) {

                arr = JSON.parse(JSON.stringify(this.scheduletimeZdy))  // 时间段 自定义
                console.log('arr', arr)
                for (let i = 0; i < arr.length; i++) {
                //     // arr[i].beginschedule = this._TimeZH(arr[i].beginschedule, 2)
                //     // arr[i].endschedule = this._TimeZH(arr[i].endschedule, 2)
                    if (arr[i].begintime.length > 6) {
                        arr[i].begintime = this._TimeZH(arr[i].begintime, 1)
                    }
                    if (arr[i].endtime.length > 6) {
                        arr[i].endtime = this._TimeZH(arr[i].endtime, 1)
                    }
                    arr[i].begintime = this._TimeZH(arr[i].beginschedule, 2) + ' ' + arr[i].begintime
                    arr[i].endtime = this._TimeZH(arr[i].endschedule, 2) + ' ' + arr[i].endtime

                    arr[i].beginschedule = '0'
                    arr[i].endschedule = '0'

                }

            }
            return arr
            // this.scheduletime = arr
            // console.log('scheduletime',this.scheduletime)
        },
        handleChange(vaule) {

        },
         // 设置图片信息（本地）
        setCoverfile(img) {
            // 发生头像图片变更操作
            // this.$refs.coverfile.setImage( this.starMgtForm.logodata.furl)
            // $("input[name=headerimg]:checked").prop('checked',false)    // 清除选中头像
            // this.form.logodata = img
            this.form.coverattid = img.key  // 活动LogoID
            this.form.coveratturlid = img.furl // 活动LogoUrl地址

        },
        // _time(time) {
        //     const temp = new Date(time);
        //     return fecha.format(temp, 'yyyy-MM-dd');
        // },
        ...mapActions([
            'setLoading'
        ])
    },
    
    components: {
        Upload
    }
}
</script>

<style lang="scss" type="text/scss">
.activeDetails {
    .el-icon-delete  {
        cursor: pointer
    }
    .title {
        margin-bottom: 20px;
        font-size: 16px;
        color: #303133;
        padding-left: 10px;
        border-left: solid 2px #409eff;
    }
    .flex {
        display: flex;
        flex-wrap: nowrap;
        align-content: flex-start;
        align-items: center;

        p,
        .el-input {
            margin-right: 10px
        }
    }
    .input {
        margin-right: 5px
    }
    textarea {
        display: block;
        width: 100%;
        height: 100%;
    }
    .el-form-item__label {
        text-align: left
    }
    .el-input__icon {
        line-height: normal
    }
    .activename {
        input {
            width: 480px
        }
    }
    .maxnum {
        input {
            width: 319px
        }
    }
    .zk-item {
        margin-top: 10px;

        .el-input,
        input {
            width: 120px
        }
    }
    .el-tooltip {
        margin-left: 10px;
    }
    i.el-tooltip.el-icon-warning.item {
        color: #C0C4CC;
        font-size: 14px;
    }
    .el-input-number {
        width: 100px;
        .el-input__inner {
            padding-left: 10px;
            padding-right: 10px;
            text-align: center;
            height: 32px;
            padding-top: 2px;
        }
        .el-input-number__decrease, .el-input-number__increase {
            width: 32px;
            height: 32px;
            color: #fff;
            background: #409EFF
        }
    }
    .pay {
        overflow: hidden;
        .item {
            margin-top: 20px;
            .bz {
                color: #C0C4CC
            }

        }

    }
   .avatar-uploader{
        box-sizing: border-box;
        width: 318px;
        height: 178px;

        .el-upload {
            border: 1px dashed #d9d9d9;
            border-radius: 6px;
            cursor: pointer;
            position: relative;
            overflow: hidden;
        }
        .el-upload:hover {
            border-color: #409EFF;
        }
        .icon_upload:before {
            background-size: 30%;
            background-position: center;
        }
        .avatar-uploader-icon {
            font-size: 28px;
            color: #8c939d;
            width: 212px;
            height: 126px;
            line-height: 178px;
            text-align: center;
        }
    }
    .btn {
        margin-top: 40px
    }
    .pztype {
        float: left;
        margin-left: 30px;
        width: 300px;
        min-height: 534px;
        background: #f2f6fc;
        .top {
            margin-top: 7px;
        }
        .text {
            padding: 16px 13px;
            box-sizing: border-box; 
            font-size: 12px;
            background: #fff;
        }

        img {
            display: block;
            width: 100%;
        }   
    }
    .timedel {
        margin-left: 5px
    }
}
</style>
